import React from 'react'

export default props => {
    return (
        <div className="d-flex align-items-center min-vh-100">
            <div className="container text-center">
                <h1>
                    <i className="now-ui-icons loader_gear spin"></i>
                </h1>
            </div>
        </div>
    )
}